import { useNavigate } from 'react-router'
import { Button, Typography, useTheme } from '@mui/material'

import BackButton from '../../../components/back-button'
import Carousel from '../../../components/carousel'
import ScreenContainer from '../../../components/screen'
import SensorActivationFooter from '../../../components/sensor-activation-footer'
import RemoveBatteryCoverImg from '../../../images/leak-freeze-activation/turn-on-sensor/remove-battery-cover.svg'
import RemoveBatteryTabImg from '../../../images/leak-freeze-activation/turn-on-sensor/remove-battery-tab.svg'
import ReplaceBatteryCoverImg from '../../../images/leak-freeze-activation/turn-on-sensor/replace-battery-cover.svg'
import { useActivationContext } from '../../../providers/activation-provider'
import useStyles from '../index.styles'
import Slide from '../slide'

const TurnOnSensorLeakFreeze = () => {
  const navigate = useNavigate()
  const { activationLocationState } = useActivationContext()
  const theme = useTheme()
  const classes = useStyles

  return (
    <ScreenContainer
      useDarkBackground={true}
      headerProps={{
        title: 'Activate',
        showDownloadAppButton: false,
        leftIcon: <BackButton />,
        useDarkBackground: true,
        progress: 20,
      }}
      footerSpacing={148}
    >
      <Typography variant="h5" sx={classes.heading}>
        Follow instructions below
      </Typography>
      <Carousel
        iconColor={theme.palette.common.white}
        slides={[
          <Slide image={RemoveBatteryCoverImg} title="Step 1" subtitle="Remove battery cover" />,
          <Slide image={RemoveBatteryTabImg} title="Step 2" subtitle="Remove battery pull-tab" />,
          <Slide image={ReplaceBatteryCoverImg} title="Step 3" subtitle="Replace battery cover" />,
        ]}
      />

      <SensorActivationFooter
        primaryButton={
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            sx={{ paddingX: 4 }}
            onClick={() => navigate('/device-connection', { state: activationLocationState })}
          >
            Next
          </Button>
        }
        sxFooter={classes.footer}
      />
    </ScreenContainer>
  )
}

export default TurnOnSensorLeakFreeze
